import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Table from "../../components/Table";
import Spinner from "../../components/Spinner";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import { loadClosedTicketsU } from "../../redux/tasks/ticketsT";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

const TableColumns = [
   {
      Header: "Subject",
      accessor: "subject",
   },
   {
      Header: "Department",
      accessor: "department",
   },

   {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => {
         return value === "RESOLVED"
            ? "Resolved"
            : value === "MARKEDASRESOLVED"
            ? "Marked as Resolved"
            : value === "WORKINPROGRESS"
            ? "Work in Progress"
            : "Un-Assigned";
      },
   },
   {
      Header: "Last Updated On",
      accessor: "updatedAt",
      Cell: ({ value }) => {
         return format(new Date(value), "MM-dd-yyyy");
      },
   },
];

const ClosedTickets = ({ loading, tickets, loadClosedTicketsU }) => {
   const navigate = useNavigate();
   const [numberOptions] = useState([5, 10, 15, 20, 25, 30]);

   useEffect(() => {
      loadClosedTicketsU();
   }, [loadClosedTicketsU]);

   const handleData = (index) => {
      const ticket = tickets[index];
      navigate("/single-ticket", { state: { ticket } });
   };

   return loading ? (
      <Spinner />
   ) : (
      <div className="flex flex-col h-screen">
         <TopBar />
         <div className="flex flex-1 overflow-hidden">
            <Sidebar />
            <main className="flex-1 p-4 overflow-y-auto">
               <div className=" mx-auto p-4">
                  <h2 className="text-3xl font-bold text-center mb-6">
                     Your Closed Tickets
                  </h2>
                  {tickets?.length > 0 ? (
                     <Table
                        data={tickets}
                        columns={TableColumns}
                        numberOptions={numberOptions}
                        dataFun={handleData}
                     />
                  ) : (
                     <>
                        <h4 className="text-xl text-center my-20">
                           No Closed Tickets found
                        </h4>
                     </>
                  )}
               </div>
            </main>
         </div>
      </div>
   );
};

ClosedTickets.propTypes = {
   loading: PropTypes.bool,
   tickets: PropTypes.array,
   loadClosedTicketsU: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
   loading: state.tickets.closedTicketsLoading,
   tickets: state.tickets.closedTickets,
});

export default connect(mapStateToProps, { loadClosedTicketsU })(ClosedTickets);
